module.exports = __webpack_public_path__ + "static/media/rope-protection.6177fcd0.jpeg";